import clsx from "clsx";
function BorderWrapper(props:any){
    const {className,children,style,...rest} =props
    return<div style={style??{}}
        className={
            clsx("d-flex g-3 align-items-center p-c-10 rounded-3 border border-1 ",className)
        }
        {...rest}
    >
        {children}

    </div>
}

export default BorderWrapper
